App.factory('CampaignContinuingCareRecalls', ['restmod', (restmod) => {
  return restmod.model('/campaigns/continuing_care_recalls')
}])
